module.exports = __webpack_public_path__ + "static/media/discount-active.e556dadb.svg";